import React from 'react';
import { SignModal } from './sign-modal';
import { SignatureImage } from './signature-image';
import SignaturePad from 'signature_pad';
import { lazyInject } from 'src/signature/ioc';
import { SignModalStore } from 'src/signature/stores/sign-modal.store';
import { FormSignatureRequestModel } from 'src/api';
import { SignatureProps } from './signature';

interface MobileSignModalState {
    isCanvasEmpty: boolean;
}

export class MobileSignModal extends React.PureComponent<SignatureProps, MobileSignModalState> {
    @lazyInject(SignModalStore) private signModalStore!: SignModalStore;

    signaturePad?: SignaturePad;
    canvas?: HTMLCanvasElement;

    constructor(props: SignatureProps) {
        super(props);
        this.state = {
            isCanvasEmpty: true,
        };
    }

    setIsCanvasEmpty = (isCanvasEmpty: boolean) => {
        this.setState({ isCanvasEmpty });
    };

    bindCanvas = (el: HTMLCanvasElement | null) => {
        if (!el) return;

        this.canvas = el;
        this.signaturePad = new SignaturePad(this.canvas);
        this.resizeCanvas();
        window.addEventListener('resize', this.resizeCanvas);
    };

    unbindCanvas = () => {
        this.clearCanvas();
        if (this.signaturePad) {
            this.signaturePad.off();
        }
        window.removeEventListener('resize', this.resizeCanvas);
    };

    resizeCanvas = () => {
        if (!this.canvas || !this.signaturePad) {
            return;
        }

        const canvasContext = this.canvas.getContext('2d');
        if (!canvasContext) return;

        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        this.canvas.width = this.canvas.offsetWidth * ratio;
        this.canvas.height = this.canvas.offsetHeight * ratio;
        canvasContext.scale(ratio, ratio);
        this.clearCanvas();
    };

    clearCanvas = () => {
        if (!this.signaturePad) return;
        this.signaturePad.clear();
        this.setState({ isCanvasEmpty: true });
        this.signModalStore.setIsLoading(false);
    };

    handleClickSubmit = () => {
        const { document } = this.props;
        if (!this.signaturePad) return;
        if (this.signaturePad.isEmpty()) {
            alert('Please provide your signature.');
            return;
        }

        const dataURL = this.signaturePad.toDataURL();
        this.signModalStore.signDocument(document, {
            signatureBase64: dataURL,
        });
    };

    handleClickCancel = () => {
        this.clearCanvas();
        this.props.handleClose();
        // cancel axios request
    };

    render() {
        const { document, open } = this.props;
        const { isCanvasEmpty } = this.state;

        return (
            <SignModal
                open={open}
                signatureInput={
                    <SignatureImage
                        isCanvasEmpty={isCanvasEmpty}
                        setIsCanvasEmpty={this.setIsCanvasEmpty}
                        bindCanvas={this.bindCanvas}
                        unbindCanvas={this.unbindCanvas}
                        clearCanvas={this.clearCanvas}
                    />
                }
                signatureFieldCount={
                    (document as FormSignatureRequestModel).blankSignatureFieldCount
                }
                canSubmit={!isCanvasEmpty}
                onSubmit={this.handleClickSubmit}
                onCancel={this.handleClickCancel}
            />
        );
    }
}
